import { render, staticRenderFns } from "./plainGroup.vue?vue&type=template&id=ba0ea2e8&scoped=true"
import script from "./plainGroup.vue?vue&type=script&lang=js"
export * from "./plainGroup.vue?vue&type=script&lang=js"
import style0 from "./plainGroup.vue?vue&type=style&index=0&id=ba0ea2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ea2e8",
  null
  
)

export default component.exports